import React from "react";
import { OpenInNew } from "@mui/icons-material";
import { publications, researchRoles } from "../data/portfolioData";
import "./Research.css";

const ResearchLink = ({ href, children }) => (
  <a className="inline-link" href={href} target="_blank" rel="noopener noreferrer">
    {children}
    <OpenInNew fontSize="inherit" aria-hidden="true" />
  </a>
);

const Research = () => (
  <section id="research" className="portfolio-section research-section" data-scene-section="research">
    <div className="section-wrap" data-animate="true">
      <header className="destination-heading destination-heading--split">
        <div>
          <div className="destination-label"><span>03</span><span>Orbital observatory</span></div>
          <h2 className="section-title">Research that measures how software gets built.</h2>
        </div>
        <p className="section-lede">Publications and active research spanning engineering education, contribution patterns, AI learning tools, and acoustic conservation.</p>
      </header>
      <div className="research-columns">
        <div className="research-column">
          <h3><span aria-hidden="true">A</span> Publications</h3>
          <ol className="research-list publication-list">
            {publications.map((publication, index) => (
              <li key={publication.title}>
                <article>
                  <div className="research-meta">
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    <span>{publication.year}</span>
                  </div>
                  <h4><ResearchLink href={publication.linkUrl}>{publication.title}</ResearchLink></h4>
                  <p className="research-organization">{publication.venue}</p>
                  <p>{publication.summary}</p>
                </article>
              </li>
            ))}
          </ol>
        </div>
        <div className="research-column">
          <h3><span aria-hidden="true">B</span> Research roles</h3>
          <ol className="research-list role-list">
            {researchRoles.map((role, index) => (
              <li key={`${role.title}-${role.period}`}>
                <article>
                  <div className="research-meta">
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    <span>{role.period}</span>
                  </div>
                  <h4>{role.title}</h4>
                  <p className="research-organization">{role.organization}</p>
                  <p>{role.summary}</p>
                  {role.linkUrl && <ResearchLink href={role.linkUrl}>{role.linkLabel}</ResearchLink>}
                </article>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default Research;
